/* Native scrolling, finite motion, visible content without enhancement. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 800px)');
  const rail = document.querySelector('[data-spell-rail]');
  if (rail) {
    const cards = [...rail.querySelectorAll('.category-card')];
    const controls = document.querySelector('[data-spell-controls]');
    const previous = controls.querySelector('[data-spell-prev]');
    const next = controls.querySelector('[data-spell-next]');
    const status = controls.querySelector('[data-spell-status]');
    let frame;
    const nearestIndex = () => cards.reduce((best, card, index) => Math.abs(card.offsetLeft - cards[0].offsetLeft - rail.scrollLeft) < Math.abs(cards[best].offsetLeft - cards[0].offsetLeft - rail.scrollLeft) ? index : best, 0);
    const sync = () => {
      controls.hidden = !mobile.matches;
      const index = nearestIndex();
      status.textContent = `${index + 1} / ${cards.length}`;
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    };
    const go = (index) => rail.scrollTo({left:cards[Math.max(0,Math.min(index,cards.length - 1))].offsetLeft - cards[0].offsetLeft,behavior:reduced.matches?'auto':'smooth'});
    previous.addEventListener('click', () => go(nearestIndex() - 1));
    next.addEventListener('click', () => go(nearestIndex() + 1));
    rail.addEventListener('scroll', () => {cancelAnimationFrame(frame);frame=requestAnimationFrame(sync);},{passive:true});
    rail.addEventListener('keydown', event => {
      if (!mobile.matches || event.altKey || event.ctrlKey || event.metaKey) return;
      if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const current = cards.indexOf(document.activeElement);
      const index = event.key==='Home'?0:event.key==='End'?cards.length - 1:(current<0?nearestIndex():current)+(event.key==='ArrowRight'?1:-1);
      const safe = Math.max(0,Math.min(index,cards.length - 1));
      cards[safe].focus({preventScroll:true});go(safe);
    });
    mobile.addEventListener('change',sync);
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(rail);
    sync();
  }
  if (!reduced.matches && 'IntersectionObserver' in window) {
    const elements=[...document.querySelectorAll('[data-editorial-reveal],.portal-gateway__intro,.story__content>div')];
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {if(entry.isIntersecting){entry.target.classList.remove('awaiting-reveal');observer.unobserve(entry.target);}}),{threshold:.08});
    document.documentElement.classList.add('signature-motion');
    elements.forEach(element => {element.setAttribute('data-editorial-reveal','');element.classList.add('awaiting-reveal');observer.observe(element);});
    reduced.addEventListener('change',() => {if(reduced.matches){elements.forEach(el=>el.classList.remove('awaiting-reveal'));observer.disconnect();}});
  }
  const contact=document.querySelector('[data-quiet-contact]');
  if(contact){
    document.addEventListener('click',event=>{if(!contact.contains(event.target))contact.open=false;});
    contact.addEventListener('keydown',event=>{if(event.key==='Escape'){contact.open=false;contact.querySelector('summary').focus();}});
    if('IntersectionObserver' in window){
      const visible=new Set();
      const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>entry.isIntersecting?visible.add(entry.target):visible.delete(entry.target));contact.classList.toggle('is-context-hidden',visible.size>0);},{threshold:.15});
      document.querySelectorAll('.order-submit,.premium-contact__actions,.explore-club__form,.hero__actions,.ll-reader').forEach(el=>observer.observe(el));
    }
  }
})();
